<template>
    <div>
        <Banner v-show="currentStep.step === 'banner'" />

        <div class="container" v-if="currentStep.showNavigation">
            <Navigation />
        </div>

        <div class="container">
            <Vehicle v-if="currentStep.step === 'vehicle'" />
            <Confirm v-if="currentStep.step === 'confirm'" />
            <Complete v-if="currentStep.step === 'complete'" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Navigation from "./Navigation.vue";
import Banner from "./steps/Banner.vue";
import Vehicle from "./steps/Vehicle.vue";
import Confirm from "./steps/Confirm.vue";
import Complete from "./steps/Complete.vue";

export default {
    components: { Navigation, Banner, Vehicle, Confirm, Complete },
    computed: {
        ...mapGetters(["currentStep"]),
    },
};
</script>
